import './index.css';
const AVATAR_TYPOGRAPHY_MAP = {
    24: 'subtitle-4-semibold',
    40: 'subtitle-1-semibold',
    48: 'subtitle-1-semibold',
    96: 'title-3-semibold',
    208: 'title-1-semibold',
};
var LettersLength;
(function (LettersLength) {
    LettersLength[LettersLength["Min"] = 1] = "Min";
    LettersLength[LettersLength["Max"] = 2] = "Max";
})(LettersLength || (LettersLength = {}));
const formatLetters = (letters) => {
    if (letters.length > LettersLength.Max) {
        // TODO: Отправлять событие в Sentry
        // `Magritte component Avatar: Prop "letters" are not valid. No more than ${LettersLength.Max} letters`
        return letters.slice(0, LettersLength.Max);
    }
    else if (letters.length < LettersLength.Min) ;
    return letters;
};

export { AVATAR_TYPOGRAPHY_MAP, formatLetters };
//# sourceMappingURL=utils.js.map
